import { localizedText, getLocale } from '../../common-js/LanguageMap';

export default function ($scope, $rootScope, $state, $log, $timeout, addonFactory, $window, DrawpService) {
    const pageName = 'active-subscription-list';
    const progressText = 'Loading...';

    $scope.activeSubscriptions = [];
    $scope.stateTitle = 'Manage your active subscriptions';
    $scope.backState = ($rootScope.previousState && $rootScope.previousState.name && $rootScope.previousState.name !== 'activeSubscriptionsList') ? $rootScope.previousState.name : 'addonAppIndex';
    $scope.stateClass = 'fitb4-item';
    $scope.serverToken = '';
    $scope.error = null;
    $scope.progress = progressText;
    $scope.enableReload = true;

    $scope.aboutDfsLogoSrc = 'https://drawpforschool.com/wp-content/themes/dfs/images/logo_drawpforschool_full.svg';

    const ERROR_MESSAGE = addonFactory.API_CALL_ERROR.GENERICERROR;

    const showProgress = (show, message) => {

        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;

            if (show) {
                $scope.progress = message;
            }
        });
    };

    const showError = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;

            if (show) {
                $scope.error = message;
                if (message === addonFactory.API_CALL_ERROR.QUOTAERROR) {
                    $scope.enableReload = false;
                } else {
                    $scope.enableReload = true;
                }
            }
        });
    };

    const errorHandler = (error) => {
        const errorResp = addonFactory.errorHandler(error, $scope);
        showError(true, errorResp);

        if (errorResp === addonFactory.API_CALL_ERROR.QUOTAERROR) {
            DrawpService.gAErrorEvent(pageName, addonFactory.getActiveAccountEmail(), error.message, $scope.serverToken);
        }
    };

    const getSubscriptionsList = () => {
        DrawpService.getActiveSubscriptions().then((response) => {
            $timeout(() => {
                const getResponse = response.data;
                $scope.activeSubscriptions = getResponse.subscriptions;
            });
        }).catch((error) => {
            $log.error('An error has occurred while fetching the active subscriptions and subscription detail.', error);
            errorHandler(error);
        }).finally(() => {
            $log.info([...document.querySelectorAll('#renew-toggle-switch')].length);

            [...document.getElementsByTagName('mdc-list > renew-toggle-switch')].map(el => {
                const switchElement = mdc.switchControl.MDCSwitch(el);
                $log.info(switchElement.checked);
                return false;
            });

            showProgress(false, '');
        });
    };

    const init = () => {
        showProgress(true, progressText);
        getSubscriptionsList();
    };

    angular.element(document).ready(() => {
        // $scope.presentationId = document.getElementById('presentationId').textContent.trim();
        $scope.userEmail = document.getElementById('userEmail').textContent.trim();
        $scope.serverToken = document.getElementById('serverToken').textContent.trim();

        DrawpService.gAPageview(pageName, pageName, null, null, $scope.serverToken);

        init();
    });

    $scope.getExpiryDate = (subscription) => {
        if (subscription.subscription_due_on == null && subscription.subscription_days_left === 5000) {
            return 'You have unlimited premium access to the Drawp for School Add-on Tool.';
        }

        if (subscription.subscription_days_left <= 0) {
            return 'Your subscription has expired.';
        }

        const date = new Date(subscription.subscription_due_on.replace(' ', 'T'));
        const months = ['Jan', 'Feb', 'Mar', 'April', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

        if (subscription.cancel_at_period_end == null || subscription.cancel_at_period_end) {
            return `Your subscription expires on ${months[date.getMonth()]} ${date.getDate().toString()}, ${date.getFullYear().toString()}\n(${subscription.subscription_days_left} days remaining)`;
        }

        return `Your subscription renews on ${months[date.getMonth()]} ${date.getDate().toString()}, ${date.getFullYear().toString()}\n(${subscription.subscription_days_left} days remaining)`;
    };

    $scope.showRenewView = (subscription) => {
        if (subscription.subscription_due_on == null && subscription.subscription_days_left === 5000) {
            return false;
        }

        if (subscription.cancel_at_period_end == null) {
            return false;
        }

        return true;
    };

    $scope.getBundleName = (name) => {
        return name.replace('Google Slide -', '');
    };

    $scope.hangleRenewToggleChange = (checked, subscription) => {
        showProgress(true, progressText);
        DrawpService.renewSubscriptionToggle(checked, subscription.bundle_id, $scope.serverToken).then((response) => {
            const newActiveSubscriptionList = [];
            $scope.activeSubscriptions.map(sub => {
                if (sub.subscription_id === subscription.subscription_id) {
                    const updatedSub = sub;
                    updatedSub.cancel_at_period_end = !checked;
                    newActiveSubscriptionList.push(updatedSub);
                } else {
                    newActiveSubscriptionList.push(sub);
                }
                return sub;
            });

            $timeout(() => {
                $scope.activeSubscriptions = newActiveSubscriptionList;
                showProgress(false);
            });
        }).catch((error) => {
            $log.error('An error has occurred while toggling the auto-renew subscription.', error);
        });
    };
};